import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { AddSuggestion } from '../AddSuggestion/AddSuggestion';
import { useSuggestions } from '../../Suggestions/useSuggestions';
import { Tooltip } from '../../../../../../CommonComponents/OPL/Tooltip/Tooltip';
import { Icon } from '../../../../../../CommonComponents/OPL/Icon/Icon';
import { isAdviserArea as selectIsAdviserArea } from '../../../../../../CommonSelectors/CommonAreaSelector';
import { SUGGESTIONS_TOOLTIP_TEXT } from '../../Tasks.constants';

interface SuggestionsHeaderProps {
  debtType?: number;
}

export const SuggestionsHeader = ({ debtType }: SuggestionsHeaderProps) => {
  const [showAddForm, setShowAddForm] = useState(false);

  const { isFetching, data } = useSuggestions();

  const isAdvisor = useSelector(selectIsAdviserArea);

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={16}>
        <Box display="flex" alignItems="center">
          <Text fontSize="h6" fontWeight={500} as="h2">
            Suggestions
          </Text>

          {!isAdvisor && (
            <Tooltip content={SUGGESTIONS_TOOLTIP_TEXT}>
              <Icon className="far fa-info-circle" color="neutral.500" fontSize="small" ml="4" />
            </Tooltip>
          )}
        </Box>

        {isAdvisor && (
          <Box display="flex">
            <Button
              disabled={showAddForm || isFetching}
              leftIcon="fal fa-plus-circle"
              variant="subtleActive"
              onClick={() => setShowAddForm(true)}
              aria-label="Add suggestion"
              aria-expanded={showAddForm}
            >
              Suggestion
            </Button>
          </Box>
        )}
      </Box>

      {showAddForm && (
        <AddSuggestion
          setFormVisibility={setShowAddForm}
          debtType={debtType}
          pulseCheckCategory={data?.goal.PulseCheckCategory}
        />
      )}
    </Box>
  );
};
